export function openPaymentAuthorization(url) {
  const target = new URL(url);
  if (target.origin !== "https://connect.sandbox.pagbank.com.br" || target.pathname !== "/oauth2/authorize") {
    throw new Error("Endereço de autorização inválido.");
  }
  window.location.assign(target.href);
}
